import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as constants from "../../constants"; 
import { getThemeDetails } from "../../modules/fiscalUpgrade/services/Settings/ThemesService";

export const fetchThemeDetailsByClientId = createAsyncThunk(
  "theme/fetchThemeDetailsByClientId",
  async ({ tDate, clientId }: { tDate: any; clientId: any }) => { 
    const response = await getThemeDetails(tDate, clientId); 
    if (response.status === constants.STATUS_CODES.SUCCESS && response.data) {
      const base64Image = response.data.data[0]?.image;
      if (base64Image) {
        return `data:image/gif;base64,${base64Image}`;
      }
    }
    return null;
  }
);

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    resolvedBackgroundImage: null as string | null,
    refreshFlag: false,  
  },
  reducers: {
    toggleRefreshFlag: (state) => {
      state.refreshFlag = !state.refreshFlag;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchThemeDetailsByClientId.fulfilled, (state, action) => {
      state.resolvedBackgroundImage = action.payload;
    });
  },
});

export const { toggleRefreshFlag } = themeSlice.actions;
export default themeSlice.reducer;

